import classNames from 'classnames';
import ReactTooltip from 'react-tooltip';
import moment from 'moment';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Alert } from 'reactstrap';
import trainingProgramsActions from '../../store/training-programs/action-creators';

class TrainingProgramTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filteredTrainingPrograms: this.props.trainingPrograms,
      filterByType: '',
    };
  }

  // ----------------------
  // Lifecycle
  // ----------------------

  componentWillReceiveProps(nextProps) {
    if (nextProps.trainingPrograms) {
      this.setState({
        filteredTrainingPrograms: nextProps.trainingPrograms,
        filterByType: '',
      });
    }
  }

  // ----------------------
  // Handlers
  // ----------------------

  onActivateTrainingProgram(trainingProgramGuid) {
    this.props.activateTrainingProgram(trainingProgramGuid);
  }

  onReviseTrainingProgram(trainingProgramGuid) {
    this.props.reviseTrainingProgram(trainingProgramGuid).then((draftGuid) => {
      this.onViewTrainingProgram(draftGuid);
    });
  }

  onViewTrainingProgram(trainingProgramGuid) {
    this.props.setSelectedTrainingProgramGuid(trainingProgramGuid);
    if (this.props.userContext.hasScope('admin')) {
      this.props.history.push(`/admin/training-programs/${trainingProgramGuid}`);
    } else {
      this.props.history.push(`/training-programs/${trainingProgramGuid}`);
    }
  }

  // ----------------------
  // Methods
  // ----------------------

  getCanRevise(trainingProgram) {
    if (trainingProgram.status !== 'current') {
      return false;
    }
    const { type } = trainingProgram;
    return (
      !this.props.trainingPrograms.find((existingProgram) => {
        return (
          existingProgram.type === type && existingProgram.status === 'draft'
        );
      }) && this.props.userContext.hasScope(['depadmin', 'admin'])
    );
  }

  getStatusBadgeClasses(statusString) {
    return statusString === 'Revised'
      ? 'badge badge-primary'
      : 'badge badge-secondary';
  }

  filterByType(trainingProgramType) {
    const filteredTrainingPrograms = !trainingProgramType
      ? this.props.trainingPrograms
      : this.props.trainingPrograms.filter((trainingProgram) => {
        return trainingProgram.type === trainingProgramType;
      });
    this.setState({
      filteredTrainingPrograms,
      filterByType: trainingProgramType,
    });
  }

  canEditOrActivate(trainingProgram) {
    return (
      trainingProgram.status === 'draft' &&
      this.props.userContext.hasScope(['depadmin', 'admin'])
    );
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <div>
        {this.state.filteredTrainingPrograms && (
          <Fragment>
            <form className="table-filters">
              <div className="form-group">
                {/* eslint-disable-next-line */}
                <label htmlFor="filterByType">
                  Filter by training program type
                </label>
                <select
                  className="form-control"
                  id="filterByType"
                  name="filterByType"
                  onChange={event => this.filterByType(event.target.value)}
                  value={this.state.filterByType}
                >
                  <option value="">All</option>
                  <option value="abbreviated">Abbreviated</option>
                  <option value="standard">Standard</option>
                </select>
              </div>
            </form>
            {!this.state.filteredTrainingPrograms.length ? (
              <Alert color="primary">
                No training programs for selected type
              </Alert>
            ) : (
              <Fragment>
                <table className="table table-stripped">
                  <thead>
                    <tr>
                      <th onClick={() => this.sortByProperty('name')}>
                        <div className="header">
                          <span>Type </span>
                          <div className="filterActions">
                            <i className="fa fa-angle-up" />
                            <i className="fa fa-angle-down" />
                          </div>
                        </div>
                      </th>
                      <th>
                        <div className="header">
                          <span>Status </span>
                        </div>
                      </th>
                      <th>
                        <div className="header">
                          <span>Created </span>
                        </div>
                      </th>
                      <th>
                        <div className="header">
                          <span>Actions </span>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.filteredTrainingPrograms.map((trainingProgram, index) => {
                        return (
                          <tr key={index.toString()}>
                            <td>{trainingProgram.getCapitalized('type')}</td>
                            <td>
                              <span
                                className={this.getStatusBadgeClasses(trainingProgram.getCapitalized('status'))}
                              >
                                {trainingProgram.getCapitalized('status')}
                              </span>
                            </td>
                            <td>
                              {moment(trainingProgram.createdAt).format('MMM D, YYYY')}
                            </td>
                            <td className="td-actions">
                              <ReactTooltip
                                place="top"
                                className="customTheme"
                                effect="solid"
                              />
                              {this.canEditOrActivate(trainingProgram) ? (
                                <button
                                  data-tip="Edit"
                                  className="button default small"
                                  onClick={() =>
                                    this.onViewTrainingProgram(trainingProgram.guid)
                                  }
                                >
                                  <i className="fa fa-edit" />
                                </button>
                              ) : (
                                <button
                                  data-tip="Details"
                                  className="button default small"
                                  onClick={() =>
                                    this.onViewTrainingProgram(trainingProgram.guid)
                                  }
                                >
                                  <i className="fa fa-list" />
                                </button>
                              )}
                              {this.getCanRevise(trainingProgram) && (
                                <button
                                  data-tip="Revise"
                                  className="button default small"
                                  onClick={() =>
                                    this.onReviseTrainingProgram(trainingProgram.guid)
                                  }
                                >
                                  <i className="fa fa-repeat" />
                                </button>
                              )}
                              {this.canEditOrActivate(trainingProgram) && (
                                <button
                                  data-tip="Activate"
                                  className="button default small"
                                  onClick={() =>
                                    this.onActivateTrainingProgram(trainingProgram.guid)
                                  }
                                >
                                  <i className="fa fa-play-circle-o" />
                                </button>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </Fragment>
            )}
          </Fragment>
        )}
      </div>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    userContext: state.common.userContext,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    activateTrainingProgram: (trainingProgramGuid) => {
      return dispatch(trainingProgramsActions.activateTrainingProgram(trainingProgramGuid));
    },
    reviseTrainingProgram: (trainingProgramGuid) => {
      return dispatch(trainingProgramsActions.reviseTrainingProgram(trainingProgramGuid));
    },
    setSelectedTrainingProgramGuid: (trainingProgramGuid) => {
      return dispatch(trainingProgramsActions.setSelectedTrainingProgramGuid(trainingProgramGuid));
    },
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TrainingProgramTable));
